import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmEmail } from '../../api/BackendApi'; 
import { AuthLayout } from '../../components/AuthComponents.jsx'; 
import { Loader2, CheckCircle, AlertTriangle } from 'lucide-react';

const ConfirmEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('Ověřujeme Vaší adresu, prosím čekejte...');

  // Prevent double-firing in strict mode
  const hasAttempted = useRef(false);

  useEffect(() => {
    if (hasAttempted.current) return;
    
    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    if (!uid || !token) {
      setStatus('error');
      setMessage('Invalid confirmation link. No UID or token found.');
      return;
    }

    hasAttempted.current = true;

    const activateEmail = async () => {
      try {
        const response = await confirmEmail({ uid, token });
        setStatus('success');
        setMessage(response.message || 'Email confirmed successfully! You can now log in.');
        window.dataLayer.push({ event: 'sign_up' });
      } catch (err) {
        setStatus('error');
        setMessage(err.message || 'Failed to confirm email. The link may be invalid or expired.');
      }
    };

    activateEmail();
  }, [searchParams]);

  const getPageTitle = () => {
    if (status === 'success') return 'Účet aktivován';
    if (status === 'error') return 'Chyba aktivace';
    return 'Ověřování emailu';
  };

  return (
    <AuthLayout title={getPageTitle()}>
      <div className="text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-indigo-600 animate-spin" />
            <p className="mt-4 text-lg font-medium">{message}</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 mx-auto text-green-600" />
            <p className="mt-4 text-lg font-medium text-gray-800">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="w-full justify-center flex px-4 py-2 mt-6 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Přihlásit se
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <AlertTriangle className="w-12 h-12 mx-auto text-red-600" />
            <p className="mt-4 text-lg font-medium text-red-800">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="w-full justify-center flex px-4 py-2 mt-6 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Zpět na přihlášení
            </button>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default ConfirmEmailPage;

